module.exports = __webpack_public_path__ + "static/img/bg-secondary-banner-management-posterImg.e4d4e36d.png";